import {
  deselectLeafMultipleSelectionOption,
  deselectMultipleSelectionOption,
  initializeChildOptions,
  initializeQuantity,
  initializeQuestions,
  initializeRelations,
  initializeSizeChart,
  initializeUniqueOptions,
  initializeUniqueOptionsBackup,
  saveQuantity,
  selectLeafMultipleSelectionOption,
  selectMultipleSelectionOption,
  toggleSingleSelectionOption,
  updateUniqueOptions,
} from './actions';

import { createReducer } from '@reduxjs/toolkit';

export const childOptionsReducer = createReducer({}, (builder) => {
  builder
    .addCase(initializeChildOptions, (state, action) => action.payload)
    .addCase(deselectLeafMultipleSelectionOption, (state, action) => {
      const { code, key } = action.payload;
      const subOptionDict = Object.keys(state).includes(code) ? state[code] : {};
      const options = Object.keys(subOptionDict).includes(key) ? subOptionDict[key] : [];
      options.forEach((option) => {
        option.isSelected = false;
        option.quantity = 0;
      });
    })
    .addCase(selectLeafMultipleSelectionOption, (state, action) => {
      const { code, key, quantities } = action.payload;
      const subOptionDict = Object.keys(state).includes(code) ? state[code] : {};
      const options = Object.keys(subOptionDict).includes(key) ? subOptionDict[key] : [];
      Object.entries(quantities).forEach((entry) => {
        const [codeValue, quantity] = entry;
        const index = options.findIndex((option) => option.codeValue === codeValue);
        if (index >= 0) {
          options[index].isSelected = quantity > 0;
          options[index].quantity = quantity;
        }
      });
    });
});

export const quantityReducer = createReducer(0, (builder) => {
  builder
    .addCase(initializeQuantity, (state, action) => action.payload)
    .addCase(saveQuantity, (state, action) => action.payload);
});

export const questionsReducer = createReducer([], (builder) => {
  builder.addCase(initializeQuestions, (state, action) => action.payload);
});

export const relationsReducer = createReducer({}, (builder) => {
  builder.addCase(initializeRelations, (state, action) => action.payload);
});

export const sizeChartReducer = createReducer({}, (builder) => {
  builder.addCase(initializeSizeChart, (state, action) => action.payload);
});

export const uniqueOptionsReducer = createReducer({}, (builder) => {
  builder
    .addCase(deselectMultipleSelectionOption, (state, action) => {
      const { code, codeValue } = action.payload;
      const options = Object.keys(state).includes(code) ? state[code] : [];
      const index = options.findIndex((option) => option.codeValue === codeValue);
      if (index >= 0) {
        options[index].isSelected = false;
        options[index].quantity = 0;
      }
    })
    .addCase(selectMultipleSelectionOption, (state, action) => {
      const { code, codeValue, quantity } = action.payload;
      const options = Object.keys(state).includes(code) ? state[code] : [];
      const index = options.findIndex((option) => option.codeValue === codeValue);
      if (index >= 0) {
        options[index].isSelected = true;
        options[index].quantity = quantity;
      }
    })
    .addCase(initializeUniqueOptions, (state, action) => action.payload)
    .addCase(toggleSingleSelectionOption, (state, action) => {
      const { code, codeValue } = action.payload;
      const options = Object.keys(state).includes(code) ? state[code] : [];
      options.forEach((option) => {
        option.isSelected = option.codeValue === codeValue;
        option.quantity = 0;
      });
    })
    .addCase(updateUniqueOptions, (state, action) => {
      const { uniqueOptionDict } = action.payload;
      for (let [code, uniqueOptions] of Object.entries(uniqueOptionDict)) {
        if (Object.keys(state).includes(code)) {
          state[code] = uniqueOptions;
        }
      }
    });
});

export const uniqueOptionsBackupReducer = createReducer({}, (builder) => {
  builder.addCase(initializeUniqueOptionsBackup, (state, action) => action.payload);
});

const bomReducer = {
  childOptions: childOptionsReducer,
  quantity: quantityReducer,
  questions: questionsReducer,
  relations: relationsReducer,
  sizeChart: sizeChartReducer,
  uniqueOptions: uniqueOptionsReducer,
  uniqueOptionsBackup: uniqueOptionsBackupReducer,
};
export default bomReducer;
